export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14032.27f8a6ed.jpg";